<template>
  <div id="app" :class="{ cover: $route.name === 'cover' }">
    <router-view />
    <mq-layout mq="md+">
      <Nav />
    </mq-layout>
    <mq-layout :mq="['xsm', 'sm', 'tb']">
      <DrawerNav />
    </mq-layout>
  </div>
</template>

<script>
import Nav from '@/components/common/Nav';
import DrawerNav from '@/components/common/DrawerNav';

export default {
  components: { Nav, DrawerNav }
};
</script>

<style lang="scss"></style>
